// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase 설정
const firebaseConfig = {
  apiKey: "AIzaSyCwNAChks2KJNuoxjBg_D-jPAXn_TEzQ1s",
  authDomain: "worldlandcafe.firebaseapp.com",
  projectId: "worldlandcafe",
  storageBucket: "worldlandcafe.firebasestorage.app",
  messagingSenderId: "506822927818",
  appId: "1:506822927818:web:35f6072cdc020a09e61b33",
  measurementId: "G-920T4W8QET"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// 서비스 초기화
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Analytics (선택사항)
export const analytics = getAnalytics(app);

export default app;